import {
  CHANGE_CREATED_BY_FILTER,
  CHANGE_SORT_BY,
  CHANGE_TYPE_FILTER,
  FETCH_LANDING_PAGES_ASYNC,
  SET_IS_VISITED,
} from './constants'

const fetchLandingPages = () => ({ type: FETCH_LANDING_PAGES_ASYNC.INITIATE })
export const fetchLandingPagesSuccess = (data) => ({
  type: FETCH_LANDING_PAGES_ASYNC.SUCCESS,
  payload: { data },
})
const fetchLandingPagesCancel = () => ({
  type: FETCH_LANDING_PAGES_ASYNC.CANCEL,
})
export const fetchLandingPagesError = (error) => ({
  type: FETCH_LANDING_PAGES_ASYNC.ERROR,
  error,
})

const changeCreatedByFilter = (value) => ({
  type: CHANGE_CREATED_BY_FILTER,
  payload: { value },
})
const changeTypeFilter = (value) => ({
  type: CHANGE_TYPE_FILTER,
  payload: { value },
})
const changeSortBy = (value) => ({ type: CHANGE_SORT_BY, payload: { value } })
const setIsVisited = (value) => ({
  type: SET_IS_VISITED,
  payload: { value },
})

export default {
  // to props
  fetchLandingPages,
  fetchLandingPagesCancel,
  changeCreatedByFilter,
  changeTypeFilter,
  changeSortBy,
  setIsVisited,
}
